import ReachAlert from '@reach/alert';
import classNames from 'classnames';
import { ChangeEvent, useCallback } from 'react';
import IconInfoCircleOutline from '@picsart/icons/IconInfoCircleOutline';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';

import { Button } from '../Button/Button';

import useStyles from './styles';
import { IUploadAlert } from './types';

function UploadAlert({
  onClose,
  handleUpload,
  className,
  description,
  accept,
  multiple,
  buttonText = 'Try again',
}: IUploadAlert) {
  const classes = useStyles();
  const processSelectedFiles = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const files = Array.from(event.target.files || []) as [File];
      event.target.value = '';

      handleUpload(files);
    },
    [handleUpload],
  );

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classNames(classes.alert)}>
        <IconInfoCircleOutline fill="#080808" />

        <ReachAlert type="polite" className={classes.textContent}>
          <p className={classNames(classes.description)}>
            {description}{' '}
            <label className={classes.label} htmlFor="tryAgainButton">
              {buttonText}
              <input
                className={classes.input}
                id="tryAgainButton"
                type="file"
                onChange={processSelectedFiles}
                multiple={multiple}
                accept={accept}
              />
            </label>
          </p>
        </ReachAlert>
        {onClose && (
          <Button className={classes.btnClose} variant="icon">
            <IconCrossLarge fill="#080808" onClick={onClose} />
          </Button>
        )}
      </div>
    </div>
  );
}

export default UploadAlert;
